import { render, staticRenderFns } from "./desuLimitbs.vue?vue&type=template&id=d23b548c&scoped=true"
import script from "./desuLimitbs.vue?vue&type=script&lang=js"
export * from "./desuLimitbs.vue?vue&type=script&lang=js"
import style0 from "./desuLimitbs.vue?vue&type=style&index=0&id=d23b548c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23b548c",
  null
  
)

export default component.exports